import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/user',
      component: ()=> import('./views/user/login.vue'),
      children: [
        {
          path: 'user',
          component: ()=> import('./views/user/login.vue'),
          meta: {title: '登录'}
        }
      ]
    },
    {
      path: '/user/logins',
      component: () => import('./views/user/logins.vue')
    }, 
    {
      path: '/user/cmccAuth',
      component: () => import('./views/user/cmccAuth.vue')
    }, 
    {
      path: '/user/bindPhone',
      component: () => import('./views/user/bindPhone.vue')
    },  
    {
      path: '/user/bindPhone1',
      component: () => import('./views/user/bindPhone1.vue')
    },    
    {
      path: '/user/home',
      component: () => import('./views/user/home.vue'),
      meta: {title: '业务中心'}
    },
    {
      path: '/user/queryFlux',
      component: () => import('./views/user/queryFlux.vue'),
      meta: {title: '流量查询'}
    },
    {
      path: '/user/recharge',
      component: () => import('./views/user/recharge.vue'),
      meta: {title: '套餐订购'}
    },
    {
      path: '/user/verified',
      component: () => import('./views/user/verified.vue'),
      meta: {title: '实名认证'}
    },
    {
      path: '/user/verifiedQh',
      component: () => import('./views/user/verifiedQh.vue'),
      meta: {title: '实名认证'}
    },
    {
      path: '/user/verifiedOtherQh',
      component: () => import('./views/user/verifiedOtherQh.vue'),
      meta: {title: '实名认证'}
    },
    {
      path: '/user/rechargeDetail',
      name: 'rechargeDetail',
      component: () => import('./views/user/rechargeDetail.vue'),
      meta: {title: '充值详情'}
    },
    {
      path: '/user/feedback',
      redirect: '/user/feedback/question',
      component: () => import('./views/user/feedback.vue'),
      children: [
          {
            path: 'list',
            component: () => import('./views/user/question.vue')
          },
          {
            path: 'question',
            component: () => import('./views/user/submitQuestion.vue')          
          }
      ],
      meta: {title: '问题反馈'}      
    },
    {
      path: '/user/buyCard',
      redirect: '/user/buyCard/buyChangeCard',
      component: () => import('./views/user/buyCard.vue'),
      children: [
          {
            path: 'buyChangeCard',
            component: () => import('./views/user/buyChangeCard.vue')
          },
          {
            path: 'buyChangeCardQuestion',
            component: () => import('./views/user/buyChangeCardQuestion.vue')          
          }
      ],
      meta: {title: '购买卡'}
    },
    {
      path: '/user/questionDetail',
      component: () => import('./views/user/questionDetail.vue'),
      meta: {title: '问题详情'}
    },
    {
      path: '/user/chgCardQuery',      
      component: () => import('./views/user/chgCardQuery.vue'),
      meta: {title: '换卡中心'}
    },
    {
      path: '/user/userChgCard',
      name: 'userChgCard',
      component: () => import('./views/user/userChgCard.vue'),
      meta: {title: '换卡中心'}
    },
    {
      path: '/agent/login',
      component: () => import('./views/agent/login.vue'),
      meta: {title: '商户登录'} 
    },
    {
      path: '/agent/home',
      component: () => import('./views/agent/home.vue'),
      meta: {title: '业务中心'}
    },
    {
      path: '/agent/secondBack',
      component: () => import('./views/agent/secondBack.vue'),
      meta: {title: '秒返设置'} 
    },
    {
      path: '/agent/distribut',
      component: () => import('./views/agent/simDistribut.vue'),
      meta: {title: '卡片分销'}   
    },
    {
      path: '/agent/notify',
      component: () => import('./views/agent/notify.vue'),
      meta: {title: '我的公告'}
    },
    {
      path: '/agent/notifyDetail',
      name: 'notifyDetail',
      component: () => import('./views/agent/notifyDetail.vue'),
      meta: {title: '公告详情'}   
    },
    {
      path: '/agent/distributRecord',
      component: () => import('./views/agent/distributRecord.vue'),
      meta: {title: '分销记录'}
    },
    {
      path: '/agent/agentBindVx',
      component: () => import('./views/agent/agentBindVx.vue'),
      meta: {title: '微信绑定'}
    },
    {
      path: '/agent/recharge',
      component: () => import('./views/agent/recharge.vue'),
      meta: {title: '预充值'}  
    },
    {
      path: '/agent/pkg',
      component: () => import('./views/agent/pkg.vue'),
      meta: {title: '套餐类别'} 
    },
    {
      path: '/agent/myprice',
      component: () => import('./views/agent/myprice.vue'),
      meta: {title: '佣金明细'} 
    },
    {
      path: '/agent/buysim',
      component: () => import('./views/agent/buysim.vue'),
      meta: {title: '买卡列表'} 
    },
    {
      path: '/agent/myorder',
      component: () => import('./views/agent/myorder.vue'),
      meta: {title: '订单管理'} 
    },
    {
      path: '/agent/card',
      component: () => import('./views/agent/card.vue'),
      meta: {title: '卡片管理'}
    },


    {
      path: '/user/simLogin',
      component: () => import('./views/user/simLogin.vue'),
      meta: {title: '卡号登录'}
    },
    {
      path: '/user/simOpen19',
      component: () => import('./views/user/simOpen19.vue'),
      meta: {title: '优惠活动'}
    },
    {
      path: '/user/simOpen9',
      component: () => import('./views/user/simOpen9.vue'),
      meta: {title: '优惠活动'}
    },
    {
      name:'applySalePkg',
      path: '/user/applySalePkg',
      component: () => import('./views/user/applySalePkg.vue'),
      meta: {title: '赠送金兑换卷'}  
    },





    {
      path: '/agent/distribut',
      component: () => import('./views/agent/simDistribut.vue'),
      meta: {title: '卡片分销'}   
    },
    {
      path: '/agent/card2',
      component: () => import('./views/agent/card2.vue'),
      meta: {title: '套餐管理'}
    },{
      path: '/agent/addUser',
      component: () => import('./views/agent/addUser.vue'),
      meta: {title: '客户管理'}
    },
    {
      path: '/agent/rechargeRecord',
      component: () => import('./views/agent/rechargeRecord.vue'),
      meta: {title: '预充值记录'}  
    },
    {
      path: '/agent/onlineService',
      component: () => import('./views/agent/onlineService.vue'),
      meta: {title: '在线客服'}  
    },
    {
      path: '/user/couponToReceive',
      component: () => import('./views/user/couponToReceive.vue'),
      meta: {title: '领券中心'}  
    },
    {
      path: '/user/cardSetUp',
      component: () => import('./views/user/cardSetUp.vue'),
      meta: {title: '充值中心'}  
    },
    {
      path: '/user/loginBInd',
      component: () => import('./views/user/loginBInd.vue'),
      meta: {title: '实名'}  
    },
    {
      path: '/user/huodong',
      component: () => import('./views/user/huodong.vue'),
      meta: {title: '预存活动'}  
    },
    {
      path: '/user/otherBindPhone',
      component: () => import('./views/user/otherBindPhone.vue'),
      meta: {title: '实名'}  
    },
    {
      path: '/user/balanceRecharge',
      component: () => import('./views/user/balanceRecharge.vue'),
      meta: {title: '余额充值'}  
    },
    {
      path: '/user/balanceRechargeRecord',
      component: () => import('./views/user/balanceRechargeRecord.vue'),
      meta: {title: '充值记录'}  
    },
    {
      path: '/user/notify',
      component: () => import('./views/user/notify.vue'),
      meta: {title: '我的公告'}  
    },
    {
      path: '/user/returnPostage',
      component: () => import('./views/user/returnPostage.vue'),
      meta: {title: '邮费退还'}  
    },
    {
      path: '/user/Advertisement',
      component: () => import('./components/Advertisement.vue'),
      meta: {title: '聚量广告'}  
    },
    {
      path: '/user/login',
      component: () => import('./views/user/login2.vue'),
      meta: {title: '登录'} 
    },
    {
      path: '/user/login2',
      component: () => import('./views/user/login3.vue'),
      meta: {title: '登录'} 
    },
    {
      path: '/user/cuccAuth',
      component: () => import('./views/user/cuccAuth.vue'),
      meta: {title: '实名登记'} 
    },
   
    {
      path: '/user/buyAgentCard',
      component: () => import('./views/user/buyAgentCard.vue'),
      meta: {title: '购卡'} 
    },
    {
      path: '/user/applyCmcc',
      component: () => import('./views/user/applyCmcc.vue'),
      meta: {title: '免费领取'} 
    },
    {
      path: '/user/applyCmcc1',
      component: () => import('./views/user/applyCmcc1.vue'),
      meta: {title: '免费领取'} 
    },
    {
      path: '/user/applyCmcc2',
      component: () => import('./views/user/applyCmcc2.vue'),
      meta: {title: '免费领取'} 
    },
    {
      path: '/user/applyCmcc3',
      component: () => import('./views/user/applyCmcc3.vue'),
      meta: {title: '免费领取'} 
    },
    {
      path: '/user/applyCmcc4',
      component: () => import('./views/user/applyCmcc4.vue'),
      meta: {title: '免费领取'} 
    },
    {
      path: '/user/applyCmcc5',
      component: () => import('./views/user/applyCmcc5.vue'),
      meta: {title: '免费领取'} 
    },
    {
      path: '/user/applyCmcc6',
      component: () => import('./views/user/applyCmcc6.vue'),
      meta: {title: '免费领取'} 
    },
    {
      path: '/user/applyCmcc7',
      component: () => import('./views/user/applyCmcc7.vue'),
      meta: {title: '免费领取'} 
    },
  ]
})
